
  import { mapState, mapMutations, mapActions } from 'vuex'

  import Icon from '../Icon'
  import handoffMixin from '../../../mixins/handoff.js'

  export default {
    name: 'HandoffModeSelector',
    components: { Icon },
    mixins: [ handoffMixin ],
    props: {
      handoffModes: {
        type: Array,
        default: () => [
          {
            key: 'delivery',
            icon: 'delivery-icon',
            mobile: 'Delivery',
            desktop: 'Order Delivery',
            classes: 'icon black',
          },
          {
            key: 'pickup',
            icon: 'pickup-icon',
            mobile: 'Pickup',
            desktop: 'Order Pickup',
            classes: 'icon black',
          },
          {
            key: 'annex',
            icon: 'pickup-icon',
            mobile: 'Annex',
            desktop: 'Annex',
            classes: 'icon black',
          },
        ]
      },
      color: {
        type: String,
        default: 'primary'
      },
      hideName: {
        type: Boolean,
        default: false,
      },
      config: {
        type: Object,
      }
    },
    computed: {
      ...mapState([ 'cart' ]),
      ...mapState({
        handoffMode: state => state.order.handoffMode,
      }),
      ...mapState({
        vehicleInfo: state => state.locations.vehicleInfo,
        deliveryAddress: state => state.locations.deliveryAddress,
      }),
      isMobile() {
        return this.$mq == 'sm' || this.$mq == 'md' ? true : false
      },
      buttonSize() {
        if (this.handoffModes.length === 1) return 'handoff-mode-selector-button--full'
        if (this.handoffModes.length === 2) return 'handoff-mode-selector-button--half'
        if (this.handoffModes.length === 3) return 'handoff-mode-selector-button--one-third'

        return ''
      },
    },
    mounted() {
      if (!this.handoffMode) {
        if (this.cart && this.cart.handoff) {
          this.setHandoff({
            mode: this.cart.handoff,
            source: 'mount'
          })
        // TODO: Refactor this to use query.handoff instead of query.section
        } else if (this.$route.query && this.$route.query.section) {
          const handoffFound = this.handoffModes.find(handoff => handoff.key === this.$route.query.section)
          if (handoffFound) {
            this.setHandoff({
              mode: this.$route.query.section,
              source: 'mount'
            })
            return
          }

          this.setHandoff({
            mode: 'pickup',
            source: 'mount'
          })
        } else {
          this.setHandoff({
            mode: 'pickup',
            source: 'mount'
          })
        }
        return
      } else {
        if (this.$route.query && this.$route.query.section) {
          const handoffFound = this.handoffModes.find(handoff => handoff.key === this.$route.query.section)
          if (handoffFound) {
            this.setHandoff({
              mode: this.$route.query.section,
              source: 'mount'
            })
          }
        }
      }
    },
    methods: {
      ...mapActions([ 'getCart', 'getDeliveryLocations', 'hideCart' ]),
      ...mapActions({
        applyCartHandoff: 'checkout/applyCartHandoff',
      }),
      ...mapMutations({
        setHandoffMode: 'order/setHandoffMode'
      }),
      ...mapMutations(['setCart']),
      ...mapMutations({
            setOrderMode: 'order/setOrderMode',
            setSelectedDay: 'order/setSelectedDay',
            setSelectedTime: 'order/setSelectedTime',
        }),
      isSelected(handoffModeObj) {
        if (this.handoffMode === handoffModeObj.key) {
          return true
        }
        if (handoffModeObj.sub_handoff_modes_keys && handoffModeObj.sub_handoff_modes_keys.includes(this.handoffMode)) {
          return true
        }
        return false
      },
      setHandoff({ mode, source }) {
        this.setHandoffMode(mode)

        if (this.config?.locationCardInfo?.hasAnnex) {
          this.setCart(null)
          this.setSelectedDay(null)
          this.setSelectedTime(null)
        }

        switch (mode) {
          case 'annex':
            this.setAnnex()
            if(source === 'click') {
              this.redirectToLocationSearch();
            }
            break;
          case 'pickup':
            this.setPickup()
            if(source === 'click') {
              this.redirectToLocationSearch();
            }
            break;
          case 'delivery':
            this.setDelivery()
            break;
          case 'curbside':
            this.setCurbside()
            break;
          case 'drivethru':
            this.setDrivethru()
            break;
          case 'reservation':
            this.setReservation()
            break;
          default: break;
        }
      },
      redirectToLocationSearch() {
        document.body.style.overflow = 'auto'
        this.hideCart();
        this.$router.push(this.isCateringPage() ? '/catering' : '/locations')
      },
    }
  }
